import { Serializable } from './../../../../../../_shared/model/deserialize.service';
import { KbItem } from './kb-item.model';
export class KbColumns implements Serializable<KbColumns> {
    col1: KbItem[];
    col2: KbItem[];
    col3: KbItem[];
    col4: KbItem[];

    deserialize(input) {
        this.col1 = input.col1;
        this.col2 = input.col2;
        this.col3 = input.col3;
        this.col4 = input.col4;

        return this;
    }
}
